import { Action } from '@ngrx/store';

export enum JobActionTypes {

  GET_JOBS = '[Jobs] GET',
  GET_JOBS_SUCCESS = '[Jobs] GET Success',
  GET_JOBS_FAILURE = '[Jobs] GET Failure',

  // PAGES
  GET_JOB_PAGES = '[Job Pages] GET',
  GET_JOB_PAGES_SUCCESS = '[Job Pages] GET Success',
  GET_JOB_PAGES_FAILURE = '[Job Pages] GET Failure',

  // JOB OFFER ACTIONS
  ASSIGN_OFFER = '[Job] ASSIGN Offer',
  ASSIGN_OFFER_SUCCESS = '[Job] ASSIGN Offer Success',

  SET_JOB = '[Job] SET Job',
  SET_JOB_SUCCESS = '[Job] SET Job Success',
  SET_JOB_FAILURE = '[Job] SET Job Failure',

  EDIT_JOB = '[Job] EDIT Job',
  CREATE_JOB = '[Job] CREATE Job',

  UPDATE_JOB = '[Job] UPDATE Job',
  UPDATE_JOB_SUCCESS = '[Job] UPDATE Job Success',
  UPDATE_JOB_FAILURE = '[Job] UPDATE Job Failure',

  COPY_JOB = '[Job] COPY Job',
  COPY_JOB_SUCCESS = '[Job] COPY Job Success',
  COPY_JOB_FAILURE = '[Job] COPY Job Failure',

  ADD_PAGES_TO_REGION = '[Jobs] ADD Pages to Region',
  ADD_PAGES_TO_REGION_SUCCESS = '[Jobs] ADD Pages to Region Success',
  ADD_PAGES_TO_REGION_FAILURE = '[Jobs] ADD Pages to Region Failure',

  ASSIGN_TEAM_AND_OFFER_ALLOC = '[DocumentSegment] ASSIGN Team and offer alloc',
  ASSIGN_TEAM_AND_OFFER_ALLOC_SUCCESS = '[DocumentSegment] ASSIGN Team and offer alloc Success',
  ASSIGN_TEAM_AND_OFFER_ALLOC_FAILURE = '[DocumentSegment] ASSIGN Team and offer alloc Failure',

  SET_JOB_LOCK = '[Job] SET Job Lock',
  SET_JOB_LOCK_SUCCESS = '[Job] SET Job Lock Success',
  SET_JOB_LOCK_FAILURE = '[Job] SET Job Lock Failure',

  SWAP_SEGMENTS = '[Job] SWAP Segments',
  SWAP_SEGMENTS_SUCCESS = '[Job] SWAP Segments Success',
  SWAP_SEGMENTS_FAILURE = '[Job] SWAP Segments Failure',

  GET_STUDIO_FILES = '[Job] GET Studio Files',
  GET_STUDIO_FILES_SUCCESS = '[Job] GET Studio Files Success',
  GET_STUDIO_FILES_FAILURE = '[Job] GET Studio Files Failure',

  DELETE_JOB = '[Job] DELETE Job',
  DELETE_JOB_SUCCESS = '[Job] DELETE Job Success',
  DELETE_JOB_FAILURE = '[Job] DELETE Job Failure',

  COPY_FULL_JOB = '[Job] COPY Full Job',
  COPY_FULL_JOB_SUCCESS = '[Job] COPY Full Job Success',
  COPY_FULL_JOB_FAILURE = '[Job] COPY Full Job Failure',

  VALIDATE_PROJECT = '[Projects] VALIDATE Project',
  VALIDATE_PROJECT_SUCCESS = '[Projects] VALIDATE Project Success',
  VALIDATE_PROJECT_FAILURE = '[Projects] VALIDATE Project Failure',

  GET_PREFERENCES = '[Offers] GET Preferences',	
  GET_PREFERENCES_SUCCESS = '[Offers] GET Preferences Success',	
  GET_PREFERENCES_FAILURE = '[Offers] GET Preferences Failure',

  GET_PAGE_BACKGROUNDS = '[Job] GET Page Backgrounds',
  GET_PAGE_BACKGROUNDS_SUCCESS = '[Job] GET Page Backgrounds Success',
  GET_PAGE_BACKGROUNDS_FAILURE = '[Job] GET Page Backgrounds Failure',

  UPDATE_DOCUMENT_SEGMENT = '[DocumentSegment] UPDATE DocumentSegment',
  UPDATE_DOCUMENT_SEGMENT_SUCCESS = '[Job] UPDATE DocumentSegment Success',
  UPDATE_DOCUMENT_SEGMENT_FAILURE = '[Job] UPDATE DocumentSegment Failure',

  CLEAR_JOB_STATE = '[Job] Clear Job',
}

// JOBS
export class GetJobs implements Action {
  readonly type = JobActionTypes.GET_JOBS;
  constructor(public payload: any) {}
}
export class GetJobsSuccess implements Action {
  readonly type = JobActionTypes.GET_JOBS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetJobsFailure implements Action {
  readonly type = JobActionTypes.GET_JOBS_FAILURE;
  constructor(public payload: any) {}
}

// JOB
export class EditJob implements Action {
  readonly type = JobActionTypes.EDIT_JOB;
  constructor(public payload: any) {}
}
export class CreateJob implements Action {
  readonly type = JobActionTypes.CREATE_JOB;
  constructor(public payload: any) {}
}
export class SetJob implements Action {
  readonly type = JobActionTypes.SET_JOB;
  constructor(public payload: any) {}
}
export class SetJobSuccess implements Action {
  readonly type = JobActionTypes.SET_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class SetJobFailure implements Action {
  readonly type = JobActionTypes.SET_JOB_FAILURE;
  constructor(public payload: any) {}
}

export class CopyJob implements Action {
  readonly type = JobActionTypes.COPY_JOB;
  constructor(public payload: any) {}
}
export class CopyJobSuccess implements Action {
  readonly type = JobActionTypes.COPY_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class CopyJobFailure implements Action {
  readonly type = JobActionTypes.COPY_JOB_FAILURE;
  constructor(public payload: any) {}
}

// JOB PAGES
export class GetJobPages implements Action {
  readonly type = JobActionTypes.GET_JOB_PAGES;
  constructor(public payload: any) {}
}
export class GetJobPagesSuccess implements Action {
  readonly type = JobActionTypes.GET_JOB_PAGES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetJobPagesFailure implements Action {
  readonly type = JobActionTypes.GET_JOBS_FAILURE;
  constructor(public payload: any) {}
}

// JOBS
export class AddPagesToRegion implements Action {
  readonly type = JobActionTypes.ADD_PAGES_TO_REGION;
  constructor(public payload: any) {}
}
export class AddPagesToRegionSuccess implements Action {
  readonly type = JobActionTypes.ADD_PAGES_TO_REGION_SUCCESS;
  constructor(public payload: any) {}
}
export class AddPagesToRegionFailure implements Action {
  readonly type = JobActionTypes.ADD_PAGES_TO_REGION_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateJob implements Action {
  readonly type = JobActionTypes.UPDATE_JOB;
  constructor(public payload: any) {}
}
export class UpdateJobSuccess implements Action {
  readonly type = JobActionTypes.UPDATE_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateJobFailure implements Action {
  readonly type = JobActionTypes.UPDATE_JOB_FAILURE;
  constructor(public payload: any) {}
}

// OFFERS
export class AssignOffer implements Action {
  readonly type = JobActionTypes.ASSIGN_OFFER;
  constructor(public payload: any) {}
}
export class AssignOfferSuccess implements Action {
  readonly type = JobActionTypes.ASSIGN_OFFER_SUCCESS;
  constructor(public payload: any) {}
}


// TEAM AND OFFER ALLOC
export class AssignTeamAndOfferAlloc implements Action {
  readonly type = JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC;
  constructor(public payload: any) {}
}
export class AssignTeamAndOfferAllocSuccess implements Action {
  readonly type = JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignTeamAndOfferAllocFailure implements Action {
  readonly type = JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_FAILURE;
  constructor(public payload: any) {}
}

export class SetJobLock implements Action {
  readonly type = JobActionTypes.SET_JOB_LOCK;
  constructor(public payload: any) {}
}
export class SetJobLockSuccess implements Action {
  readonly type = JobActionTypes.SET_JOB_LOCK_SUCCESS;
  constructor(public payload: any) {}
}
export class SetJobLockFailure implements Action {
  readonly type = JobActionTypes.SET_JOB_LOCK_FAILURE;
  constructor(public payload: any) {}
}

export class SwapSegments implements Action {
  readonly type = JobActionTypes.SWAP_SEGMENTS;
  constructor(public payload: any) {}
}
export class SwapSegmentsSuccess implements Action {
  readonly type = JobActionTypes.SWAP_SEGMENTS_SUCCESS;
  constructor(public payload: any) {}
}
export class SwapSegmentsFailure implements Action {
  readonly type = JobActionTypes.SWAP_SEGMENTS_FAILURE;
  constructor(public payload: any) {}
}

// JOB STUDIO FILES
export class GetJobStudioFiles implements Action {
  readonly type = JobActionTypes.GET_STUDIO_FILES;
  constructor(public payload: any) {}
}
export class GetJobStudioFilesSuccess implements Action {
  readonly type = JobActionTypes.GET_STUDIO_FILES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetJobStudioFilesFailure implements Action {
  readonly type = JobActionTypes.GET_STUDIO_FILES_FAILURE;
  constructor(public payload: any) {}
}

// JOB STUDIO FILES
export class DeleteJob implements Action {
  readonly type = JobActionTypes.DELETE_JOB;
  constructor(public payload: any) {}
}
export class DeleteJobSuccess implements Action {
  readonly type = JobActionTypes.DELETE_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class DeleteJobFailure implements Action {
  readonly type = JobActionTypes.DELETE_JOB_FAILURE;
  constructor(public payload: any) {}
}

// COPY FULL JOB
export class CopyFullJob implements Action {
  readonly type = JobActionTypes.COPY_FULL_JOB;
  constructor(public payload: any) {}
}
export class CopyFullJobSuccess implements Action {
  readonly type = JobActionTypes.COPY_FULL_JOB_SUCCESS;
  constructor(public payload: any) {}
}
export class CopyFullJobFailure implements Action {
  readonly type = JobActionTypes.COPY_FULL_JOB_FAILURE;
  constructor(public payload: any) {}
}

// Validate Project
export class ValidateProject implements Action {
  readonly type = JobActionTypes.VALIDATE_PROJECT;
  constructor(public payload: any) {}
}
export class ValidateProjectSuccess implements Action {
  readonly type = JobActionTypes.VALIDATE_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class ValidateProjectFailure implements Action {
  readonly type = JobActionTypes.VALIDATE_PROJECT_FAILURE;
  constructor(public payload: any) {}
}

// Company Preferences
export class GetPreferences implements Action {	
  readonly type = JobActionTypes.GET_PREFERENCES;	
  constructor(public payload: any) {}	
}	
export class GetPreferencesSuccess implements Action {	
  readonly type = JobActionTypes.GET_PREFERENCES_SUCCESS;	
  constructor(public payload: any) {}	
}	
export class GetPreferencesFailure implements Action {	
  readonly type = JobActionTypes.GET_PREFERENCES_FAILURE;	
  constructor(public payload: any) {}	
}

// Page Backgrounds
export class GetPageBackgrounds implements Action {
  readonly type = JobActionTypes.GET_PAGE_BACKGROUNDS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsSuccess implements Action {
  readonly type = JobActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsFailure implements Action {
  readonly type = JobActionTypes.GET_PAGE_BACKGROUNDS_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateDocumentSegment implements Action {
  readonly type = JobActionTypes.UPDATE_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class UpdateDocumentSegmentSuccess implements Action {
  readonly type = JobActionTypes.UPDATE_DOCUMENT_SEGMENT_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateDocumentSegmentFailure implements Action {
  readonly type = JobActionTypes.UPDATE_DOCUMENT_SEGMENT_FAILURE;
  constructor(public payload: any) {}
}

// CLEAR STATE
export class ClearJobState implements Action {
  readonly type = JobActionTypes.CLEAR_JOB_STATE;
  constructor(public payload: any) {}
}

export type All =
  | GetJobs
  | GetJobsSuccess
  | GetJobsFailure
  | GetJobPages
  | GetJobPagesSuccess
  | GetJobPagesFailure
  | EditJob
  | CreateJob
  | AssignOffer
  | AssignOfferSuccess
  | SetJob
  | SetJobSuccess
  | SetJobFailure
  | AddPagesToRegion
  | AddPagesToRegionSuccess
  | AddPagesToRegionFailure
  | AssignTeamAndOfferAlloc
  | AssignTeamAndOfferAllocSuccess
  | AssignTeamAndOfferAllocFailure
  | UpdateJob
  | UpdateJobSuccess
  | UpdateJobFailure
  | CopyJob
  | CopyJobSuccess
  | CopyJobFailure
  | SetJobLock
  | SetJobLockSuccess
  | SetJobLockFailure
  | SwapSegments
  | SwapSegmentsSuccess
  | SwapSegmentsFailure
  | GetJobStudioFiles
  | GetJobStudioFilesSuccess
  | GetJobStudioFilesFailure
  | DeleteJob
  | DeleteJobSuccess
  | DeleteJobFailure
  | CopyFullJob
  | CopyFullJobSuccess
  | CopyFullJobFailure
  | ValidateProject
  | ValidateProjectSuccess
  | ValidateProjectFailure
  | GetPreferences	
  | GetPreferencesSuccess	
  | GetPreferencesFailure
  | GetPageBackgrounds
  | GetPageBackgroundsSuccess
  | GetPageBackgroundsFailure
  | UpdateDocumentSegment
  | UpdateDocumentSegmentSuccess
  | UpdateDocumentSegmentFailure
  | ClearJobState



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/job.actions.ts